<lp-icon>{{ copied() ? 'check' : 'content_copy' }}</lp-icon>
<span class="label" [class.visible]="copied()">copied!</span>
